var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FlexContainer } from './FlexContainer';
import { FONT, Font, FontWeight, TextElement, getFontSizeString } from './TextElement';
export const TextInput = (props) => {
    const { helperText, helperTextColor, disabled, style, fontSize = 16 } = props, rest = __rest(props, ["helperText", "helperTextColor", "disabled", "style", "fontSize"]);
    const cursor = disabled ? 'default' : undefined;
    const backgroundColor = disabled ? 'rgba(239, 239, 239, 0.3)' : undefined;
    const color = disabled ? 'rgb(84, 84, 84)' : undefined;
    const outline = disabled ? 'none' : undefined;
    const caretColor = disabled ? 'transparent' : undefined;
    return _jsxs(FlexContainer, { gap: '8px', children: [isAreaProps(rest) && _jsx("textarea", Object.assign({}, rest, { style: Object.assign({ border: '2px' + " solid #CFCFCF", cursor,
                    backgroundColor,
                    color, borderRadius: '20px', padding: '15px', fontSize: getFontSizeString(fontSize), letterSpacing: getFontSizeString(0.04 * fontSize), fontFamily: FONT[Font.Inter], fontWeight: FontWeight.Medium, resize: 'none', outline,
                    caretColor }, style), className: 'greyPlaceholderColor' })), !isAreaProps(rest) && _jsx("input", Object.assign({}, rest, { type: 'text', style: Object.assign({ border: '2px' + " solid #CFCFCF", cursor,
                    backgroundColor,
                    color, borderRadius: '20px', padding: '15px', fontSize: getFontSizeString(fontSize), letterSpacing: getFontSizeString(0.04 * fontSize), fontFamily: FONT[Font.Inter], fontWeight: FontWeight.Medium, resize: 'none', outline,
                    caretColor }, style), className: 'greyPlaceholderColor' })), helperText && _jsx(TextElement, { font: Font.Inter, fontSize: 12, text: helperText, color1: helperTextColor, fontWeight: FontWeight.Medium, centered: true })] });
};
function isAreaProps(props) {
    return props.type === 'area';
}
//# sourceMappingURL=TextArea.js.map